<template>
	<div class="container">
		<div class="bg-white rounded-lg shadow-xs p-4 border border-gray-200">
			<div class="flex items-start space-x-3">
				<div class="flex-1">
					<div
						class="flex items-center gap-2"
						style="padding-top: 1%; padding-bottom: 1%"
					>
						<img
							v-if="displayName === 'Saturn Support'"
							src="@static/favicon.ico"
							class="size-7 flex-none rounded-full bg-gray-50"
							alt="balloon payment"
						/>
						<i
							v-else
							class="fas fa-user size-7 rounded-full bg-gray-50 flex items-center justify-center"
							style="color: var(--main-color); font-size: larger"
						></i>
						<div class="font-medium text-gray-800">
							{{ displayName }}
						</div>
						<div class="text-gray-400 text-xs">
							{{ formatDate(date) }}
						</div>
					</div>
					<div class="text-gray-600 text-sm">
						{{ comment }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
	export interface ICommentProps {
		comment: string;
		author: string;
		date: string;
	}
</script>
<script setup lang="ts">
	import { ref, computed } from 'vue';

	const props = defineProps<ICommentProps>();
	const comment = ref(props.comment);
	const author = ref(props.author);
	const date = ref(props.date);

	const displayName = computed(() => {
		return author.value === 'Automation for Jira' ? 'You' : 'Saturn Support';
	});

	const formatDate = (dateString: string) => {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleString('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: true,
		});
	};
</script>
<style scoped lang="css">
	@import 'tailwindcss';
	@reference 'tailwindcss';
</style>
